import { render, staticRenderFns } from "./DashSkeleton.vue?vue&type=template&id=9a2947fa&"
import script from "./DashSkeleton.vue?vue&type=script&lang=js&"
export * from "./DashSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports